module.exports = __webpack_public_path__ + "img/pdf_preview_principles_apc_de.113b27b6.png";